module.exports = __webpack_public_path__ + "d1c1dcbb1c976dc2b7c1941826bc1208.ttf";